<template>
  <GmapMap
    :center="center"
    :zoom="8"
    map-type-id="terrain"
    style="width: 100%; height: 400px"
    ref="map"
  >
    <GmapPolyline v-bind:path.sync="paths" v-bind:options="ploptions"/>
    <GmapMarker
      :key="`A${index}`"
      v-for="(m, index) in markers"
      :position="m.position"
      :clickable="true"
      :draggable="true"
      :title="m.name"
      :icon="{ 
        url: require(`@/assets/${m.icon}`),
        size: {width: 32, height: 32, f: 'px', b: 'px',},
        scaledSize: {width: 32, height: 32, f: 'px', b: 'px',}
      }"
      @click="toggleInfoWindow(m,index)"
    >
      <GmapInfoWindow
        :opened="m.infoWinOpen"
        :options="infoOptions"
        :position="m.position"
        @closeclick="m.infoWinOpen=false"
      >
        <div v-html="m.infoContent"/>
        <span v-if="!m.infoContent">{{m.name}}</span>
      </GmapInfoWindow>
    </GmapMarker>
  </GmapMap>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    data() {
      return {
        center: {
          lat: 0,
          lng: 0
        },
        markers: [],
        paths: [],
        ploptions: {
          strokeOpacity: 0.5,
          strokeWeight: 4,
          strokeColor: '#ff0000',
          fillColor: '#ff0000',
          fillOpacity: 0.4
        },
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: 1
          },
        }
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      const app = this;
      let id = app.$route.params.id;
      app.itemId = id;
      axios.get(`api/v1/public/products/${id}`)
        .then(function (resp) {
          app.item = resp.data;
          app.init(app.item);
        })
        .catch(function (resp) {
          console.log(resp);
          app.openSnackbar({ type: 'error' });
        });
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      init(item){
        let $this = this;
        if(item.business){
          const business = item.business;
          if(item.prod_distributors){
            const npps = item.prod_distributors;
            npps.forEach(function(npp, index){
              if(npp.vi_tri && npp.vi_tri.split(";").length > 1) {
                $this.markers.push({
                  position:{
                    lat: parseFloat(npp.vi_tri.split(";")[0]), 
                    lng: parseFloat(npp.vi_tri.split(";")[1])
                  },
                  name: npp.ten_npp,
                  address: npp.dia_chi,
                  infoWinOpen: true,
                  icon: 'cart.png'
                });
                $this.paths.push({
                  lat: parseFloat(business.vi_tri.split(";")[0]), 
                  lng: parseFloat(business.vi_tri.split(";")[1])
                });
                $this.paths.push({
                  lat: parseFloat(npp.vi_tri.split(";")[0]), 
                  lng: parseFloat(npp.vi_tri.split(";")[1])
                });
              }
            });
          }
          if(business.vi_tri && business.vi_tri.split(";").length > 1){
            $this.markers.push({
              position:{
                lat: parseFloat(business.vi_tri.split(";")[0]),
                lng: parseFloat(business.vi_tri.split(";")[1])
              },
              name: business.ten_co_so,
              address: business.dia_chi,
              logo: business.avatar,
              infoWinOpen: true,
              icon: 'home.png'
            });

            $this.center = {
              lat: parseFloat(business.vi_tri.split(";")[0]), 
              lng: parseFloat(business.vi_tri.split(";")[1])
            };
          }
        }
      },
      toggleInfoWindow: function (marker, idx) {
        marker.selectedLocation = location;
        this.markers.map(function(value, key) {
          if(key==idx)
            value.infoWinOpen = false;
        });

        marker.infoContent = this.getInfoWindowContent(marker);
        
        if (this.currentMidx == idx) {
          marker.infoWinOpen = !marker.infoWinOpen;
        }
        else {
          marker.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function (marker) {
        let img_src = require('@/assets/tglogo.png');
        if(marker.logo){
          img_src = `${this.config.beUrl}/uploads/${marker.logo}`;
        }
        return (`<div id="iw_container">
          <div style="float:left;border: 1px solid;">
            <img width="100" height="100" src="${img_src}">
          </div>
          <div style="float:right; padding: 10px;">
            <div class="iw_title">${marker.name}</div>
            <div class="iw_content">
              <i class="mdi mdi-map-marker-outline mdi-18px text-success"></i>
              ${marker.address}
            </div>
          </div>
        </div>`);
      },
    },
  };
</script>
<style>
  #iw_container .iw_title {
    font-size: 16px;
    font-weight: bold;
  }
  .iw_content {
    padding: 15px 15px 15px 0;
  }
</style>
